var _g, _rect, _rect2, _rect3, _rect4, _g2, _g3, _g4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg108(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 194,
    viewBox: "0 0 208 194",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2662_2290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.3569 38C49.3569 26.9543 58.3112 18 69.3569 18H137.357C148.403 18 157.357 26.9543 157.357 38V61.936C157.357 72.9817 148.403 81.936 137.357 81.936H49.3569V38Z",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 66.7139,
    y: 31.5,
    width: 49.68,
    height: 3.85714,
    rx: 1.92857,
    fill: "#E4E4E4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 66.7139,
    y: 42.4286,
    width: 73.008,
    height: 3.85714,
    rx: 1.92857,
    fill: "#E4E4E4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 66.7139,
    y: 53.3572,
    width: 32.4,
    height: 3.85714,
    rx: 1.92857,
    fill: "#E4E4E4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 66.7139,
    y: 64.2857,
    width: 49.68,
    height: 3.85714,
    rx: 1.92857,
    fill: "#E4E4E4"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dddd_2662_2290)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_2662_2290)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 88.7143,
    width: 106.704,
    height: 34.56,
    rx: 12,
    fill: "#EF0505"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 86.7197,
    y: 103.5,
    width: 56.16,
    height: 3.85714,
    rx: 1.92857,
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_2662_2290)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 57.3438,
    y: 95.3174,
    width: 20.304,
    height: 20.304,
    rx: 8,
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2662_2290)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.0353 107.749C71.5429 107.749 71.1247 108.072 70.9812 108.517H69.6155V106.854H70.6995C72.0467 106.854 73.1427 105.758 73.1427 104.411C73.1427 103.122 72.1401 102.063 70.8741 101.974C70.6855 101.355 70.3136 100.797 69.8084 100.384C69.2239 99.9062 68.4856 99.6429 67.7292 99.6429C67.0499 99.6429 66.3979 99.8485 65.8436 100.237C65.3717 100.569 64.9995 101.011 64.7563 101.527C63.9339 101.54 63.2602 102.176 63.1881 102.983C62.2711 103.142 61.5713 103.943 61.5713 104.904C61.5713 105.979 62.4458 106.854 63.5208 106.854H65.0985V108.517H63.7328C63.5893 108.072 63.1711 107.749 62.6787 107.749C62.0681 107.749 61.5713 108.246 61.5713 108.856C61.5713 109.467 62.0681 109.964 62.6787 109.964C63.1711 109.964 63.5893 109.641 63.7328 109.195H65.7765V106.854H67.018V109.053C66.5727 109.196 66.2496 109.614 66.2496 110.107C66.2496 110.718 66.7464 111.214 67.357 111.214C67.9676 111.214 68.4644 110.718 68.4644 110.107C68.4644 109.614 68.1413 109.196 67.696 109.053V106.854H68.9375V109.195H70.9812C71.1247 109.641 71.5429 109.964 72.0353 109.964C72.6459 109.964 73.1427 109.467 73.1427 108.856C73.1427 108.246 72.6459 107.749 72.0353 107.749Z",
    fill: "#FC0055"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2662_2290",
    x: 19.3569,
    y: 0,
    width: 188,
    height: 143.936,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 22
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2662_2290"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2662_2290",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dddd_2662_2290",
    x: 31,
    y: 85.7143,
    width: 144.704,
    height: 103.56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2662_2290"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2662_2290",
    result: "effect2_dropShadow_2662_2290"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 26
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_2662_2290",
    result: "effect3_dropShadow_2662_2290"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 47
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_2662_2290",
    result: "effect4_dropShadow_2662_2290"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect4_dropShadow_2662_2290",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2662_2290",
    x: 0,
    y: 58.7143,
    width: 206.704,
    height: 134.56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.235294 0 0 0 0 0.313726 0 0 0 0 0.878431 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2662_2290"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2662_2290",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_2662_2290",
    x: 33.3438,
    y: 75.3174,
    width: 80.3042,
    height: 80.304,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.139757 0 0 0 0 0.211636 0 0 0 0 0.729167 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2662_2290"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2662_2290",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2662_2290"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.5714,
    height: 11.5714,
    fill: "white",
    transform: "translate(61.5713 99.6429)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg108);
export default __webpack_public_path__ + "static/media/svg108.28bb87912746e4a48d37efade285f1ec.svg";
export { ForwardRef as ReactComponent };